var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container termo"},[(_vm.identificadorEmpresa)?_c('div',{staticClass:"col-md-12 p-4"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.texto)}})]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }